<template>
  <span v-if="error">Error loading collection</span>
  <div class="grid-x margin-bottom-m">
    <h3 class="cell small-6">
      {{ title }}
    </h3>
    <button
      v-if="linkUrl"
      class="cell small-6 link"
    >
      <span
        class="secondary-cta"
        @click="followLink"
      >
        {{ linkName }}
      </span>
    </button>
  </div>
  <div class="grid-x grid-margin-x grid-margin-y">
    <ProsContentCollectionHeroImage
      v-if="deviceType !== 'medium'"
      :hero-image-style="heroImageStyle[deviceType]"
      :loading="loading"
      :recommendation-data="recommendationData"
    />
    <div
      ref="gridProductThumbnail"
      :class="`cell ${thumbnailStyles[deviceType]}`"
    >
      <ProsGrid
        :config-data="getConfigData"
        @dataLoadStatusEvent="(e) => $emit('dataLoadStatusEvent', e)"
      >
        <ProsContentCollectionHeroImage
          v-if="deviceType === 'medium'"
          :hero-image-style="heroImageStyle"
          :loading="loading"
          :recommendation-data="recommendationData"
        />
      </ProsGrid>
    </div>
  </div>
</template>

<script>
import ProsGrid from '../ProsGrid/ProsGrid';
import ProsContentCollectionHeroImage from './ProsContentCollectionHeroImage';
import { getDeviceType } from '../../utils/utils';
import constants from '../../utils/constants';
import { contentlinkClickEventTag } from '../../analytics/analyticsEvent';

const { SMALL, MEDIUM, LARGE } = constants.BREAK_POINT_TYPE;

export default {
  name: 'ProsContentCollection',
  components: {
    ProsGrid,
    ProsContentCollectionHeroImage,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['dataLoadStatusEvent'],
  data() {
    return {
      deviceType: SMALL,
      error: undefined,
      heroImageStyle: {
        [SMALL]: { height: '335px' },
        [MEDIUM]: { height: '100%' },
        [LARGE]: { height: '100%' },
      },
      impressionData: {
        media_type: 'PROS:Collections',
        content_position: 'r99s99',
      },
      loading: true,
      numberOfItems: this.configData.numberOfItems || {
        [SMALL]: 2.5,
        [MEDIUM]: 5.5,
        [LARGE]: 5.25,
      },
      thumbnailStyles: {
        [SMALL]: `${SMALL}-12`,
        [MEDIUM]: `${MEDIUM}-12`,
        [LARGE]: `${LARGE}-6`,
      },
      title: this.configData.title,
      linkUrl: this.configData.linkUrl,
      linkName: this.configData.linkName || 'Similar Items',
      recommendationData: this.configData.recommendationData || {},
    };
  },
  computed: {
    isPanelLoaded() {
      return this.$store.state?.recommendationStore?.panelLoadedMap[
        this.configData.workflow
      ]?.isLoaded;
    },
    getConfigData() {
      return {
        ...this.configData,
        editProducts: true,
        impressionData: this.impressionData,
        linkName: constants.LINK_NAME.EDIT,
        maxProduct: 6,
        numberOfItems: this.numberOfItems,
        recommendationData: this.configData.recommendationData || {},
        title: '',
        useWishList: this.configData.useWishList,
        wrapProductName: true,
      };
    },
  },
  beforeMount() {
    this.setDeviceType();
  },
  mounted() {
    window.addEventListener('resize', this.setDeviceType);
    window.addEventListener('orientationchange', this.setDeviceType);
    // TODO just for testing, later on it will replace with emit function
    setTimeout(() => {
      this.loading = false;
    }, constants.SKELETON_LOADING_TIMEOUT);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setDeviceType);
    window.removeEventListener('orientationchange', this.setDeviceType);
  },
  methods: {
    setDeviceType() {
      this.deviceType = getDeviceType();
    },
    followLink() {
      contentlinkClickEventTag(
        this.configData.recommendationData,
        this.configData.zone,
      );
      window.open(this.linkUrl, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  text-align: right;
}
</style>
